// Utility function to convert chart data to CSV format
export interface ChartSeries {
  name: string;
  data: number[];
}

export interface ChartData {
  categories: string[];
  series: ChartSeries[];
  title?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
}

export const convertChartDataToCSV = (chartData: ChartData): string => {
  if (!chartData || !chartData.categories || !chartData.series) {
    return '';
  }

  const { categories, series, xAxisTitle = 'Category', yAxisTitle = 'Value' } = chartData;
  
  // Create CSV header
  const headers = [xAxisTitle, ...series.map(s => s.name)];
  
  // Create CSV rows
  const rows = categories.map((category, index) => {
    const values = series.map(s => s.data[index] || 0);
    return [category, ...values];
  });
  
  // Combine header and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');
  
  return csvContent;
};

export const downloadChartAsCSV = (chartData: ChartData, filename?: string) => {
  const csvContent = convertChartDataToCSV(chartData);
  
  if (!csvContent) {
    return;
  }
  
  // Create filename
  const defaultFilename = chartData.title 
    ? `${chartData.title.replace(/[^a-zA-Z0-9]/g, '_')}.csv`
    : 'chart_data.csv';
  const finalFilename = filename || defaultFilename;
  
  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', finalFilename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
